'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveAttachmentsClient = undefined;

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESOLVE_ATTACHMENT_PATH = 'livechat/v1/attachment/resolve/thread';

var resolveAttachmentsClient = exports.resolveAttachmentsClient = function resolveAttachmentsClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      sessionId = _ref.sessionId,
      threadId = _ref.threadId,
      fileIds = _ref.fileIds;

  return _noAuthApiClient2.default.get(RESOLVE_ATTACHMENT_PATH + '/' + threadId, {
    query: {
      fileId: fileIds.toArray(),
      sessionId: sessionId
    }
  });
};